import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokensService } from '../services/auth/tokens.service';
import { AuthService } from '@tangilla/tg-ng-core';
import { LocalStorageService } from 'ngx-localstorage';
import { ProjectConfig } from '@tangilla/tg-ng-models/src/lib/view-models';
import { Route, Router } from '@angular/router';
import { RouteUtilsService } from '../services/utils/route.utils.service';

@Injectable({
  providedIn: 'root'
})
export class FormsApiCallsInterceptor implements HttpInterceptor {

  constructor(
    private tokensService: TokensService,
    private authService: AuthService,
    private localStorageService: LocalStorageService,
    private routeUtilsService: RouteUtilsService,
    @Inject('projectConfig') private projectConfig: ProjectConfig,
    @Inject('env') private env: any
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let headers = new HttpHeaders()
      .set('auth_token', this.token(req.url) || '');

    const duplicate = req.clone({
      headers
    });

    return next.handle(duplicate).pipe(
      catchError(error => {
        if (error.status === 401) {
        } else if (error.status === 503) {
          const queryParams = this.routeUtilsService.getCurrentUrlQueryParams();

          if (this.projectConfig.auth.saveUrlOnMaintenanceRedirect && window.location?.pathname !== '/maintenance') {
            this.localStorageService.set(this.env.localStorage.previousUrl, window.location?.pathname);
          }
          this.authService.redirectToMaintenancePage(queryParams);
        }
        throw error;
      })
    );
  }

  private token(url: string): string | undefined {
    if (url.includes(this.env.api.member)) {
      return this.tokensService.memberToken;
    } else if (url.includes(this.env.api.account)) {
      return this.tokensService.accountToken;
    } else if (url.includes(this.env.api.committee)) {
      return this.tokensService.committeeToken;
    } else if (url.includes(this.env.api.communication)) {
      return this.tokensService.communicationToken;
    } else if (url.includes(this.env.api.event)) {
      return this.tokensService.eventToken;
    } else if (url.includes(this.env.api.forms)) {
      return this.tokensService.formsToken;
    } else if (url.includes(this.env.api.billing)) {
      return this.tokensService.billingToken;
    } else if (url.includes(this.env.api.reporting)) {
      return this.tokensService.reportingToken;
    } else if (url.includes(this.env.api.utilities)) {
      return this.tokensService.utilitiesToken;
    } else if (url.includes(this.env.api.email)) {
      return this.tokensService.emailToken;
    } else if (url.includes(this.env.api.bean_counter)) {
      return this.tokensService.beanCounterToken;
    } else if (url.includes(this.env.api.state_education)) {
      return this.tokensService.stateEducationToken;
    } else {
      return '';
    }
  }
}
